import * as React from 'react'

import { LightbulbIcon, MapPinIcon, XIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// Placeholder illustration for the long-press gesture; design may replace with a Lottie.
const LongPressHintScene: React.FC = () => (
  <div
    aria-hidden="true"
    className="tw:relative tw:mx-auto tw:flex tw:h-40 tw:w-full tw:max-w-[280px] tw:flex-col tw:items-center tw:justify-center tw:gap-1 tw:overflow-hidden tw:rounded-lg tw:bg-muted"
  >
    <MapPinIcon
      className="tw:size-9 tw:text-primary"
      style={{ animation: 'hint-pin 2.4s ease-in-out infinite' }}
      fill="var(--primary)"
    />
    <span className="tw:relative tw:flex tw:size-3 tw:items-center tw:justify-center">
      <span
        className="tw:absolute tw:size-12 tw:rounded-full tw:border-2 tw:border-primary"
        style={{ animation: 'hint-hold 2.4s ease-out infinite' }}
      />
      <span className="tw:size-3 tw:rounded-full tw:bg-primary/70" />
    </span>
  </div>
)

// Not an ⓘ: the credits badge already uses one a corner away.
const MobileCreateHint: React.FC = () => {
  const [open, setOpen] = React.useState(false)
  const t = Localization.translator
  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="icon"
          aria-label={t.holdToCreateWorkflow}
        >
          <LightbulbIcon aria-hidden="true" />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <div className="tw:flex tw:items-center tw:gap-1 tw:px-1 tw:pt-1">
          <DrawerClose asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              aria-label={t.close}
            >
              <XIcon aria-hidden="true" />
            </Button>
          </DrawerClose>
          <DrawerTitle className="tw:flex-1 tw:text-center">
            {t.holdToCreateWorkflow}
          </DrawerTitle>
          <span aria-hidden className="tw:size-9 tw:shrink-0" />
        </div>
        <div className="tw:flex tw:flex-col tw:gap-4 tw:px-4 tw:pb-4">
          <LongPressHintScene />
          <DrawerDescription className="tw:text-center tw:text-sm tw:text-muted-foreground">
            {t.holdToCreateWorkflowHint}
          </DrawerDescription>
          <DrawerClose asChild>
            <Button type="button" className="tw:w-full">
              {t.gotIt}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export default MobileCreateHint
